module.exports = __webpack_public_path__ + "static/media/pk.b67f80e0.svg";